import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';

export function getColumnsMetadata() {
  return _.defaults({
    Asset: 'Asset/Text',
    AssetStatus: 'Asset/IsBlocked',
    AssetSource: 'Asset/AssetSource',
    AssetType: 'AssociationType',
    UsedByCount: 'UsedByCount',
    UsedByAssetGroupCount: 'UsedByAssetGroupCount',
    PinnedCount: 'PinnedCount',
    PerformanceRating: [
      'PerformanceLabelBestPercentage',
      'PerformanceLabelGoodPercentage',
      'PerformanceLabelLowPercentage',
      'PerformanceLabelLearningPercentage',
      'PerformanceLabelUnratedPercentage',
    ],
    AssetId: 'Asset/Id',
    PolicyStatus: 'Asset/EditorialStatus',
  }, PerformanceMetricsColumns);
}
